import {z} from 'zod';

import {advertisingCredentialsSchema} from './AdvertisingCommonSchemas';

export const enqueueRemoveAdvertisementRequestSchema = z.object({
  tenantId: z.string().uuid(),
  vehicleId: z.string().uuid().optional(),
  platformCode: z.string().min(1),
  credentials: advertisingCredentialsSchema.nullable(),
});

export type EnqueueRemoveAdvertisementRequest = z.infer<
  typeof enqueueRemoveAdvertisementRequestSchema
>;
